import { createSelector } from "@reduxjs/toolkit";

import { ideasSlice } from "@src/store/slices/experienceBuilder/ideas/slice";

const { getIdeas, getQuery, getCategory } = ideasSlice.selectors;

/**
 * The library list after applying the active category filter and search query.
 * Case-insensitive substring match on the idea title and prompt. Memoized so
 * the returned array stays referentially stable across unrelated state changes.
 */
export const getFilteredIdeas = createSelector(
  [getIdeas, getQuery, getCategory],
  (ideas, query, category) => {
    const q = query.trim().toLowerCase();
    return ideas.filter((idea) => {
      if (category !== "all" && idea.category !== category) {
        return false;
      }
      if (!q) {
        return true;
      }
      return (
        idea.title.toLowerCase().includes(q) ||
        idea.prompt.toLowerCase().includes(q)
      );
    });
  }
);
